import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=0bf49cd4&scoped=true&"
import script from "./newForm.vue?vue&type=script&lang=js&"
export * from "./newForm.vue?vue&type=script&lang=js&"
import style0 from "./newForm.vue?vue&type=style&index=0&id=0bf49cd4&scoped=true&lang=css&"
import style1 from "./newForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf49cd4",
  null
  
)

export default component.exports